import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';

interface NavigationHeaderProps {
  title: string;
  subtitle?: string;
  onBackToApp: () => void;
  showQuickNav?: boolean;
}

const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  title,
  subtitle,
  onBackToApp,
  showQuickNav = true
}) => {
  return (
    <div className="sticky top-0 z-50 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm border-b border-slate-200 dark:border-slate-700">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Back Navigation */}
          <div className="flex items-center space-x-4">
            <button
              onClick={onBackToApp}
              className="flex items-center space-x-2 px-4 py-2 bg-zippy-600 hover:bg-zippy-700 text-white rounded-lg transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Back to App</span>
            </button>
            
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-slate-800 dark:text-white">{title}</h1>
              {subtitle && (
                <p className="text-sm text-slate-600 dark:text-slate-400">{subtitle}</p>
              )}
            </div>
          </div>

          {/* Quick Navigation */}
          {showQuickNav && (
            <div className="flex items-center space-x-2">
              <button
                onClick={onBackToApp}
                className="flex items-center space-x-2 px-3 py-2 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
                title="Go to Dashboard"
              >
                <Home className="h-4 w-4" />
                <span className="hidden md:inline">Dashboard</span>
              </button>
              
              <div className="flex items-center space-x-1 px-3 py-2 bg-slate-100 dark:bg-slate-800 rounded-lg">
                <img 
                  src="/zippy-logo-simple.svg" 
                  alt="ZippyHealth Logo"
                  className="w-5 h-5"
                />
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">ZippyHealth.io</span>
              </div>
            </div>
          )}
        </div>

        {/* Mobile Title */}
        <div className="block sm:hidden mt-3">
          <h1 className="text-lg font-bold text-slate-800 dark:text-white">{title}</h1>
          {subtitle && (
            <p className="text-sm text-slate-600 dark:text-slate-400">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationHeader; 
